// Centralized site config
export const SITE = {
  name: "RVA Signs",
  longName: "RVA Signs. A Richmond signage resource.",
  ownerName: "Todd Friedman",
  phone: "804-539-7300",
  phoneHref: "tel:8045397300",
  email: "todd@rvasigns.com",
  emailHref: "mailto:todd@rvasigns.com",
  address: "Richmond, Virginia",
  tagline: "You don’t have to figure it out alone.",
  positioning: "A Richmond Signage Resource",
};

export const HOW_I_HELP = [
  { num: "01", title: "A Second Look at Sign Quotes", body: "Send over the proposal. I’ll help you understand what’s included, what may be missing, and what questions to ask before you sign." },
  { num: "02", title: "Monument Sign Questions",       body: "Costs, materials, permitting, foundations, lighting, site considerations. The stuff that affects the number on the quote." },
  { num: "03", title: "Channel Letter Help",           body: "Figuring out whether building signage is the right fit for your property, budget, and visibility goals." },
  { num: "04", title: "Permits and Landlord Approvals", body: "A heads-up on the approval issues that tend to slow projects down before they start." },
  { num: "05", title: "Budget Reality Check",          body: "A realistic sense of what projects cost in Richmond, before you start collecting bids." },
  { num: "06", title: "Finding the Right Vendor",      body: "Not every sign company is right for every project. Help thinking through fit, timeline, and scope." },
  { num: "07", title: "Sorting Out the Scope",         body: "Talking through what actually needs to happen before fabrication begins." },
];

export const PROJECT_TYPES = [
  "Monument Sign",
  "Channel Letters",
  "Tenant Panel",
  "Pylon Sign",
  "Shopping Center Signage",
  "Medical Office Signage",
  "Wayfinding Program",
  "Sign Permit Review",
  "Rebrand or Re-image",
  "Multi-Location Rollout",
  "Not Sure Yet",
];

export const BUDGET_RANGES = [
  "Under $5,000",
  "$5,000 to $15,000",
  "$15,000 to $40,000",
  "$40,000 to $100,000",
  "$100,000+",
  "Not sure yet",
];

// Signage-forward imagery. Every photo should clearly show a sign.
export const MEDIA = {
  // Hero: authentic Richmond FOR LEASE sign — local, real, unfiltered
  heroSign:       "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/zsgn3yue_Screenshot%202026-06-09%20at%208.15.04%E2%80%AFPM.png",
  monumentSign:   "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/ncbdggkp_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_15_47%20PM.png",
  channelLetters: "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/b5jq4119_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_17_02%20PM.png",
  richmondMonument: "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/x868dejj_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_15_55%20PM.png",
  neonSign:       "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/gdpfmu0l_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_16_14%20PM.png",
  shoppingCenter: "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/fo3t919j_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_16_23%20PM.png",
  hotelJohnMarshall: "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/vke4f6v5_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_16_32%20PM.png",
  shortPumpPlaza: "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/45vcu9qa_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_16_55%20PM.png",
  villageStrip:   "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/b5jq4119_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_17_02%20PM.png",
  toddPortrait:   "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/v0nymp1d_Todd%20Professional%20Headshot.png",
  toddPortraitBW: "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/u7yn3c7f_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2003_47_04%20PM.png",
};

export const PROJECTS = [
  { tag: "Downtown Landmark", title: "Hotel John Marshall Rooftop",      img: "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/vke4f6v5_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_16_32%20PM.png", location: "Downtown Richmond" },
  { tag: "Lifestyle Retail",  title: "Short Pump Plaza Signage Program", img: "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/45vcu9qa_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_16_55%20PM.png", location: "Short Pump" },
  { tag: "Strip Tenant",      title: "Village Storefront Channel Letters", img: "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/b5jq4119_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_17_02%20PM.png", location: "West End" },
];
